import { render, staticRenderFns } from "./MovieCenter.vue?vue&type=template&id=bc957c4a&scoped=true&"
import script from "./MovieCenter.vue?vue&type=script&lang=js&"
export * from "./MovieCenter.vue?vue&type=script&lang=js&"
import style0 from "./MovieCenter.vue?vue&type=style&index=0&id=bc957c4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc957c4a",
  null
  
)

export default component.exports